import actionsTypes from './actions.types';
import axios from 'axios';
import io from 'socket.io-client';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `${process.env.VUE_APP_API_LIVE_URI}/actions`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/actions`;
}

const socket = io(url);
export default {
  addAction({ commit }, data) {
    const ls = JSON.parse(localStorage.getItem('user'));
    commit(actionsTypes.ADD_ACTION_REQUEST);
    axios
      .post(`${url}/add?email=${ls.profile.email}`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(res => {
        socket
          .emit('fetch actions', { manager_email: ls.profile.email })
          .catch(err => {
            if (!err.status && !err.response) {
              return commit(actionsTypes.ADD_ACTION_FAILED, {
                error: 'Network error'
              });
            }
            if (err && err.response && err.response.status === 404) {
              return commit(actionsTypes.ADD_ACTION_FAILED, {
                error: err.response.statusText
              });
            }
            //handle payment error
            const error = err.response.data.error;
            commit(actionsTypes.ADD_ACTION_FAILED, { error });
          });
      });
  },
  fetchActions({ commit }) {
    const ls = JSON.parse(localStorage.getItem('user'));
    commit(actionsTypes.FETCH_ACTIONS_REQUEST);
    socket.emit('fetch actions', { manager_email: ls.profile.email });
    socket.on('actions', function(data) {
      commit(actionsTypes.FETCH_ACTIONS_SUCCESS, {
        data: { actions: data }
      });
    });
    socket.on('fetch action error', err => {
      return commit(actionsTypes.FETCH_ACTIONS_FAILED, {
        error: err.message
      });
    });
  },
  updateAction({ commit }, action) {
    const ls = JSON.parse(localStorage.getItem('user'));
    commit(actionsTypes.UPDATE_ACTION_REQUEST);
    axios
      .post(`${url}/update?email=${ls.profile.email}`, action, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(res => {
        /*
        commit(actionsTypes.UPDATE_ACTION_SUCCESS, {
          data: { action: res.data.action }
        });*/
        socket.emit('fetch actions', { manager_email: ls.profile.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(actionsTypes.UPDATE_ACTION_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(actionsTypes.UPDATE_ACTION_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(actionsTypes.UPDATE_ACTION_FAILED, { error });
      });
  },
  deleteAction({ commit }, action) {
    const ls = JSON.parse(localStorage.getItem('user'));
    commit(actionsTypes.DELETE_ACTION_REQUEST);
    axios
      .delete(
        `${url}/delete?email=${ls.profile.email}&action_id=${action._id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ls.accessToken}`
          }
        }
      )
      .then(res => {
        /*commit(actionsTypes.DELETE_ACTION_SUCCESS, {
          data: { action: res.data.action }
        });*/
        socket.emit('fetch actions', { manager_email: ls.profile.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(actionsTypes.DELETE_ACTION_FAILED, {
            error: 'Network error'
          });
        }

        if (err && err.response && err.response.status === 404) {
          return commit(actionsTypes.DELETE_ACTION_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(actionsTypes.DELETE_ACTION_FAILED, { error });
      });
  }
};
